import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useNavigationType, useSearchParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import apiUrl from "../../Apiurl";
import { destinazioneArticolo } from "./destinazioneArticolo";

export { destinazioneArticolo } from "./destinazioneArticolo";

export default function useSchedaArticolo({ setProductFunction, codVS } = {}) {
  const [params] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const { getAccessTokenSilently } = useAuth0();
  const articolo = codVS === undefined ? params.get("articolo") : codVS;
  const [lettura, setLettura] = useState({});
  const aperture = useRef(new Set());
  // Una entry ripristinata da F5 conserva lo state del router ma non questa
  // memoria: in quel caso chiudi rimuove il parametro senza lasciare la pagina.
  useEffect(() => {
    if (navigationType === "PUSH" && location.state?.schedaArticolo) aperture.current.add(location.key);
  }, [location.key, location.state, navigationType]);

  const apri = useCallback((codice) => {
    navigate(destinazioneArticolo(location, codice), { state: { schedaArticolo: true } });
  }, [location, navigate]);
  const chiudi = useCallback(() => {
    if (codVS !== undefined) {
      if ((window.history.state?.idx || 0) > 0) navigate(-1);
      else navigate("/", { replace: true });
    } else if (location.state?.schedaArticolo && aperture.current.has(location.key)) {
      navigate(-1);
    } else {
      const next = new URLSearchParams(location.search);
      next.delete("articolo");
      const state = { ...location.state };
      delete state.schedaArticolo;
      navigate({ pathname: location.pathname, search: next.toString() ? `?${next}` : "", hash: location.hash }, { replace: true, state });
    }
  }, [codVS, location, navigate]);

  useEffect(() => {
    if (articolo === null || articolo === undefined) {
      setLettura({});
      return undefined;
    }
    const controller = new AbortController();
    const carica = async () => {
      setLettura({ articolo, caricamento: true });
      try {
        if (!articolo.trim() || articolo.length > 15 || Array.from(articolo).some((char) => char.charCodeAt(0) < 32)) throw new Error(`Codice articolo non valido: ${articolo}`);
        const token = await getAccessTokenSilently();
        if (controller.signal.aborted) return;
        // showORcreateIDPS4 creerebbe documenti vuoti per codici inesistenti.
        const response = await axios.get(`${apiUrl}/prodotti/prodotto/showByCodVS/${encodeURIComponent(articolo)}`, {
          headers: { Authorization: `Bearer ${token}` }, signal: controller.signal,
        });
        if (controller.signal.aborted) return;
        const prodotto = Array.isArray(response.data) ? response.data.find((row) => String(row.codiceVS) === articolo) : null;
        if (!prodotto) throw new Error(`Articolo ${articolo} non trovato`);
        setProductFunction(prodotto);
        setLettura({ articolo, prodotto, caricamento: false });
      } catch (err) {
        if (!controller.signal.aborted) setLettura({ articolo, caricamento: false, errore: err?.response?.status === 404
          ? `Articolo ${articolo} non trovato` : err?.message || "Impossibile caricare l'articolo." });
      }
    };
    carica();
    return () => controller.abort();
  }, [articolo, getAccessTokenSilently, setProductFunction]);

  const corrente = lettura.articolo === articolo ? lettura : { caricamento: true };
  return { articolo, apri, chiudi, prodotto: corrente.prodotto, caricamento: corrente.caricamento, errore: corrente.errore };
}
